/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsInsideVertically: {
  name: 'chevrons-inside-vertically';
  data: string;
} = {
  name: 'chevrons-inside-vertically',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="m12.354 1.354-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L8 4.293 11.646.646a.5.5 0 0 1 .708.708Zm0 13.292-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 .708.708L8 11.707l3.646 3.647a.5.5 0 0 0 .708-.708Z" fill="currentColor"/></svg>`,
};
